
export class ComponentSpecifier{
    constructor(components,name, selector){
        var _components = components;
        var _name = name;
        var _selector = selector;

        Object.defineProperty(this,'components',{
            get: function(){ return _components }
        });

        Object.defineProperty(this,'name',{
            get: function(){ return _name }
        });

        Object.defineProperty(this,'selector',{
            get: function(){ return _selector }
        });
    }

    // =======
    // API (public)
    // -------
    getComponents(){ return this.components }
    
    getName(){ return this.name }

    getSelector(){ return this.selector }

}